import {
    ComposeMessageQuery,
    SpecialCommunityComparisonDefaults,
} from "generated/graphql";

export const getComposeMessageComponentProps = (
    composeMessage: ComposeMessageQuery["composeMessage"],
): {
    recipients: string[];
    initialRecipients?: string[];
    specialCommunityComparisonDefaults: SpecialCommunityComparisonDefaults | null;
    files: ComposeMessageQuery["composeMessage"]["files"];
} => {
    if (composeMessage.recipientSuggestions?.length > 0) {
        return {
            recipients: composeMessage.recipientSuggestions,
            initialRecipients: composeMessage.recipients,
            specialCommunityComparisonDefaults:
                composeMessage.specialCommunityComparisonDefaults,
            files: composeMessage.files,
        };
    }

    return {
        recipients: composeMessage.recipients,
        files: composeMessage.files,
        specialCommunityComparisonDefaults:
            composeMessage.specialCommunityComparisonDefaults,
    };
};
